import { notify } from '../../../utils/notification';
import apiEndpoints from '../../api';
import axiosInstance from '../../axiosInstance'
import { logOut } from '../../../utils/helpers/logOut'
import { errorMsg } from '../../../consts/responseMessages';
import { getDeviceType } from '../../../utils/helpers/getBrowserDetails';
const { detect } = require('detect-browser');
// eslint-disable-next-line no-unused-vars
const _browser = detect();


export async function societyForgotPasswordReq(action) {
    const BODY = {
        "email": action.data.email
    }

    return axiosInstance.post(apiEndpoints.SOCIETY_FORGOT_PASSWORD_API, { ...BODY })
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data.statusCode === 404) {
                notify('error', errors.response.data.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors

        })
}
export async function registerReq(action) {
    const BODY = {
        first_name: action?.data?.firstName,
        last_name: action?.data?.lastName || '',
        email: action?.data?.email,
        phone: action?.data?.phone,
        password: action?.data?.password,
    }

    return axiosInstance.post(apiEndpoints.REGISTER_API, { ...BODY })
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data.statusCode === 404 || errors.response?.data.statusCode === 400) {
                notify('error', errors.response.data.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors

        })
}

export async function loginReq(action) {
    const BODY = {
        "email": action.data.email,
        "password": action.data.password,
        "login_type": "society",
        "device_type": getDeviceType(),
        "platform": "web",
        // Geofence: employees may be blocked at sign-in if outside their
        // society premises. Coordinates are captured once in the saga and
        // injected here (null when the browser has no fix / permission).
        "latitude": action.data?.latitude ?? null,
        "longitude": action.data?.longitude ?? null,
        // "ip": action.data.ipAddress,
        // "os_version": action.data.os || browser.os,
        // "app_version": action.data.version || browser.version,
        // "phone_imei": action.data.iemi || "",
        // "phone_brand": action.data.phoneBrand || "",
        // "auto_login": action.data.autoLogin ? true : false
    }

    return axiosInstance.post(apiEndpoints.SOCIETY_CONTROLLER_LOGIN_API, { ...BODY })
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data.statusCode === 404 || errors.response?.data.statusCode === 400) {
                notify('error', errors.response.data.message);
            } else if (errors.response?.status === 403) {
                // Geofence rejection (or other forbidden) — surface the backend
                // message. The saga decides whether to offer a GPS retry.
                notify('error', errors.response.data.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors

        })
}
export async function logoutReq(action) {
    const BODY = {
        reason: action?.data?.reason,
        // Check-out location — recorded for the attendance report. Logout is
        // never blocked by the geofence, so a null fix is fine here.
        latitude: action?.data?.latitude ?? null,
        longitude: action?.data?.longitude ?? null,
    }

    return axiosInstance.post(apiEndpoints.SOCIETY_CONTROLLER_LOGOUT_API, { ...BODY })
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data.statusCode === 404 || errors.response?.data.statusCode === 400) {
                notify('error', errors.response.data.message);
            }
            else if (errors.status === 403) {
                notify('error', errors.response.data.message);
                logOut();
            }
            else {
                notify('warning', "Something went wrong");
            }
            return errors

        })
}

export async function reloginReq(action) {
    // /auth/me re-validates each employee society against the geofence, so it
    // takes the SAME coordinates as login (as query params). Undefined values
    // are dropped by axios rather than sent as "undefined".
    const params = {};
    if (action?.data?.latitude != null) params.latitude = action.data.latitude;
    if (action?.data?.longitude != null) params.longitude = action.data.longitude;

    return axiosInstance.get(apiEndpoints.SOCIETY_CONTROLLER_RELOGIN_API, { params })
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data.statusCode === 400) {
                if (!action.data.firstLogin || errorMsg.INVALID_ACCESS_TOKEN.includes(errors.response?.data.message)) {
                    logOut()
                } else {
                    notify('error', errors.response.data.message);
                }
            }
            else if (errors?.status === 401) {
                notify('error', errors.response.data.message);
                logOut()
            }
            else if (errors.response?.status === 403) {
                // Geofencing blocked every membership — the user is not at any
                // society's premises. Send them back to the GPS/login screen.
                notify('error', errors.response.data.message);
                logOut()
            }
            else if (errors.response.data.statusCode === 404) {
                notify('error', errors.response.data.message);
                logOut()
            }
            else {
                notify('warning', "Something went wrong");
            }
            return errors

        })
}


export async function passwordResetReq(action) {
    const BODY = {
        "reset_token": action.data.token,
        "password": action.data.password,
        "confirm_password": action.data.confirmPassword
    }

    return axiosInstance.post(apiEndpoints.PASSWORD_RESET_API, { ...BODY })
        .then(response => {
            return response;
        }).catch((errors) => {
            console.log("errors", errors);
            if (errors.response?.data.statusCode === 400 || errors.response.data.statusCode === 404) {
                notify('error', errors.response.data.message);
            } else {
                notify('warning', "Something went wrong");
            }
            return errors
        })
}
